import { render, staticRenderFns } from "./file-directory-types.vue?vue&type=template&id=a304d862&scoped=true"
import script from "./file-directory-types.vue?vue&type=script&lang=js"
export * from "./file-directory-types.vue?vue&type=script&lang=js"
import style0 from "./file-directory-types.vue?vue&type=style&index=0&id=a304d862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a304d862",
  null
  
)

export default component.exports